import { shallowEqual } from 'hooks/reduxHooks'
import type { CreateSelectorOptions } from 'reselect'

export const reselectShallowEqual: CreateSelectorOptions = {
  memoizeOptions: {
    resultEqualityCheck: shallowEqual,
  },
}
